import { Component, Input, Injectable } from '@angular/core';

import { AppService } from '../../../app.service';
import { DepartmentTreeService } from './department.tree.service';

import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import {MatIconModule} from '@angular/material/icon';

import { ArrayDataSource } from "@angular/cdk/collections";

/**
 * Datastructure for tree-nodes
 */

export class DepartmentNode {
    childNodes: [any];
    id: string;
    ministryName: string;
    govEntity: [any];
    hasChildren: boolean;
  }

  let counter = 0;
  interface FoodNode {
    name: string;
    children?: FoodNode[];
  }
@Injectable()
export class DepartmentDatabase {
  dataChange = new BehaviorSubject<DepartmentNode>(new DepartmentNode());
   

  /**
   * Get the tree structure object
   */
  get data(): DepartmentNode { return this.dataChange.value; }
   
  rootNode: any;
  showPeople: boolean;
  showProjects: boolean;
  showRadioButtons: boolean;

  constructor(private service: DepartmentTreeService) {
  }

  initialize(arr: any []) {
    this.rootNode = arr;
  }
}

@Component({
    selector: 'departmentTree',
    providers: [AppService, DepartmentDatabase],
    templateUrl: './department.tree.component.html',
    styleUrls: ['./department.tree.component.css']
})
export class DepartmentTreeComponent {
    @Input() showPeople: string;
    @Input() showProjects: string;
    @Input() showRadioButtons: string;
    @Input() treeArray: any [];

    @Input() setValue: string;

    TREE_DATA: FoodNode[] = []

    treeControl: NestedTreeControl<FoodNode>;
    dataSource: any;

  hasChild = (_: number, node: FoodNode) =>
    !!node.children && node.children.length > 0;

    private selectedDepartment: string;

    constructor(
        private database: DepartmentDatabase,
        private service: DepartmentTreeService,
        private appService: AppService,
        private activatedRoute: ActivatedRoute,
        private matIcon: MatIconModule
    ){
    }

    setData(){
      let tmpArr = []

      this.treeArray.forEach(element => {
        let ministryNode = {
          name: '',
          children: []
        }

        if(element.ministryName){
          ministryNode.name = element.ministryName
          
          let entityNodes = []
          if(element.govEntity !== undefined && element.govEntity.length > 0){

            element.govEntity.forEach(entity => {
              
              if(entity.entityName){
                let entityNode= {
                  name: '',
                  children: []
                }
                entityNode.name = entity.entityName
                
                let sectionNodes = [];
                
                
                if(entity.govSection != 'undefined' && entity.govSection.length > 0){
                  entity.govSection.forEach(section => {
                    if(section.sectionName){
                      let sectionNode = {
                        name: ''
                      }
                      sectionNode.name = section.sectionName;
                      entityNode.children.push(sectionNode)
                    }
                  })
                }
                ministryNode.children.push(entityNode)
              }
            });
          }
          tmpArr.push(ministryNode)
        }
        
      });

      this.TREE_DATA = tmpArr;
    }

    /**
     * Parse the input variables to their correct format and subscribe to the datasource.
     */
    ngOnInit() {
      this.setData();
      this.treeControl = new NestedTreeControl<FoodNode>(node => node.children);
      this.dataSource = new ArrayDataSource(this.TREE_DATA);
    }
    
    /**
     * Set the URL-route to the specified route
     * @param route Route to change to
     */
    private setRoute(route) {
      this.appService.setRoute(route);
    }

    /**
     * Function to set the department id when selecting departments
     * @param id the id to be set
     */
    private setDepartment(id: string) : void {
      this.selectedDepartment = id;
    }

    /**
     * Retrieve the id of the currently selected department
     */
    public getDepartmentId() : string {
      return this.selectedDepartment;
    }
}